import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  wrapper: {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(6),
    },
  },

  imgContainer: {
    position: 'relative',
    marginBottom: theme.spacing(6),
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '50%',
    height: `${
      typeof window !== 'undefined' ? (window.innerWidth - 64) * 0.5 : 0
    }px`,
    position: 'relative',
    zIndex: 1,
    borderRadius: '50%',
    boxShadow: theme.shadows[0],
    border: `1px solid ${theme.palette.background.lightOverlay}`,

    [theme.breakpoints.up('sm')]: {
      height: 200,
      width: 200,
    },

    [theme.breakpoints.up('md')]: {
      height: 300,
      width: 300,
    },
  },
}))
